//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Assemblies.js";
import "../no/Builder.js";
import "../no/ScCollector.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectObjectList.js";
let d=[[[0,"ContextComponent",0,"Assemblies.Component",0],[0,"DestinationPart",1,"Part",0],[1,"ExcludeBodiesCollector",0,"ScCollector",0],[1,"ExcludeBodiesExceptions",0,"SelectDisplayableObjectList",0],[1,"ExcludeFacesCollector",0,"ScCollector",0],[1,"ExcludeFacesExceptions",0,"SelectDisplayableObjectList",0],[1,"IncludeBodiesCollector",0,"ScCollector",0],[1,"IncludeBodiesExceptions",0,"SelectDisplayableObjectList",0],[1,"IncludeFacesCollector",0,"ScCollector",0],[1,"IncludeFacesExceptions",0,"SelectDisplayableObjectList",0],[0,"MassPropertiesOption",1,0],[1,"MaximumBlendRadius",0,"Expression",0],[1,"MaximumHoleSize",0,"Expression",0],[1,"MinimumBodySize",0,"Expression",0],[1,"ObjectsToSimplify",0,"SelectDisplayableObjectList",0],[1,"ObjectsToSimplifyCollector",0,"ScCollector",0],[0,"RemoveInternalBodies",1,0],[0,"RemoveInternalVoids",1,0],[0,"SourceAssembly",0,"Part",0],[0,"UniteBodies",1,0],[0,"UseBlendRadius",1,0],[0,"UseBodySize",1,0],[0,"UseHoleDiameter",1,0]],[[[],"Preview",{R_:{previewStatusCode:''}},0,0]],[]];
SPLM.Assemblies.SimplifyBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Assemblies.SimplifyBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Assemblies.SimplifyBuilder.MassPropertiesOptionValue = Object.freeze({
    "StoreCalculated" : "StoreCalculated", "StoreZero" : "StoreZero"});

export default SPLM;